import FourOFour from '../components/404/404'

const PageNotFound = () => {
  return (
    <FourOFour />
  )
}

export default PageNotFound